import { z } from 'zod';
import { ApprovalSchema } from '../../entities/approval';
/**
 * List Approvals
 * GET /api/v2/approvals — admins see every request of the workspace, others
 * the ones they asked for or are named on. Newest first, capped.
 */ export const ListApprovalsResponseSchema = z.object({
    approvals: z.array(ApprovalSchema),
    /** Whether the caller sees the whole workspace (admin) or only their own. */ scope: z.enum([
        'all',
        'mine'
    ])
});

//# sourceMappingURL=list-approvals.schema.js.map